<!--
 * 推荐教练弹窗组件
 * @description 预约成功页推荐添加偏好教练弹窗
 * @author suu
 * @date 2026-07-06
-->
<template>
  <van-action-sheet
    v-model="showPop"
    :close-on-click-overlay="false"
    :safe-area-inset-bottom="false"
    class="recommend-coach-pop-wrap"
  >
    <div class="recommend-coach-pop" v-if="coachInfo && coachInfo.coach_info">
      <div class="pop-title"
        >是否添加<span class="pop-title-name">{{
          coachInfo.coach_info.name
        }}</span
        >到偏好教练？</div
      >
      <div class="pop-coach">
        <img class="pop-coach-img" :src="coachInfo.coach_info.image" alt="" />
        <div class="pop-coach-desc">
          <div class="pop-coach-desc-name">{{ coachInfo.coach_info.name }}</div>
          <div class="pop-coach-desc-shop">{{
            coachInfo.coach_info.shop_name
          }}</div>
        </div>
        <div class="pop-coach-right">近期常约</div>
      </div>
      <img
        class="pop-img"
        src="https://cdnvue.gymcity.com.cn/uploads/ykcg-zysx-tjphjl?v=2"
        alt=""
      />
      <div class="pop-check-box">
        <van-checkbox v-model="checked" shape="square"
          >下次不再提醒</van-checkbox
        >
      </div>
      <div class="pop-btn-box">
        <div class="pop-btn-box-item user-btn" @click="handleClose('close')"
          >暂不添加</div
        >
        <div
          class="pop-btn-box-item pop-btn-box-item-add user-btn"
          @click="handleClose('add')"
        >
          添加
        </div>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>
/**
 * 推荐教练弹窗组件
 * @description 预约成功页推荐添加偏好教练弹窗
 */
export default {
  name: 'ReservationsRecommendCoachPop',

  props: {
    /**
     * 是否显示弹窗
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 推荐教练信息
     * @property {Object} coach_info - 教练信息
     * @property {string} coach_info.name - 教练姓名
     * @property {string} coach_info.image - 教练头像
     * @property {string} coach_info.shop_name - 门店名称
     * @property {number} coach_info.id - 教练ID
     * @property {boolean} is_show - 是否显示
     */
    coachInfo: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      checked: false // 是否不再提醒
    }
  },

  computed: {
    /**
     * 弹窗显示状态
     */
    showPop: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {
    /**
     * 监听弹窗显示状态变化
     */
    visible(val) {
      if (val) {
        this.checked = false
      }
    }
  },

  methods: {
    /**
     * 处理弹窗关闭
     * @param {string} type - 操作类型: 'add' 添加, 'close' 不添加
     */
    handleClose(type) {
      this.$emit('close', {
        type,
        checked: this.checked,
        coachId: this.coachInfo?.coach_info?.id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}

.recommend-coach-pop-wrap {
  background: #f9f9f9 !important;
  max-height: 90% !important;

  .recommend-coach-pop {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f9f9f9;
    padding-top: vw(22);
    padding-bottom: vw(10);
    padding-bottom: calc(#{vw(10)} + constant(safe-area-inset-bottom));
    padding-bottom: calc(#{vw(10)} + env(safe-area-inset-bottom));

    .pop-title {
      padding: 0 vw(34);
      font-weight: 600;
      font-size: vw(22);
      color: #050b27;
      line-height: vw(30);
      width: fit-content;
      white-space: nowrap;

      span {
        color: #ff2270;
      }
    }

    .pop-coach {
      width: vw(335);
      height: vw(64);
      box-sizing: border-box;
      background: #ffffff;
      border-radius: vw(8);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 vw(16);
      margin-top: vw(16);
      box-sizing: border-box;

      .pop-coach-img {
        width: vw(45);
        height: vw(45);
        border-radius: 50%;
        margin-right: vw(10);
      }

      .pop-coach-desc {
        flex: 1;
        margin-right: vw(10);

        .pop-coach-desc-name {
          font-weight: 600;
          font-size: vw(15);
          color: #050b27;
          line-height: vw(21);
        }

        .pop-coach-desc-shop {
          font-weight: 300;
          font-size: vw(12);
          color: rgba($color: #050b27, $alpha: 0.8);
          line-height: vw(17);
          margin-top: vw(4);
        }
      }

      .pop-coach-right {
        font-weight: 400;
        font-size: vw(13);
        color: rgba($color: #050b27, $alpha: 0.5);
        line-height: vw(18);
      }
    }

    .pop-img {
      width: vw(335);
      height: vw(315);
      object-fit: cover;
      margin-top: vw(20);
    }

    .pop-check-box {
      margin-top: vw(20);

      ::v-deep {
        .van-checkbox__icon {
          font-size: vw(20);

          .van-icon {
            width: vw(20);
            height: vw(20);
            background: #ffffff;
            border-radius: vw(4);
            border: 1px solid #dddddd;
          }
        }

        .van-checkbox__icon--checked .van-icon {
          color: #fff;
          background-color: #ff2270;
          border-color: #ff2270;
        }

        .van-checkbox__label {
          font-weight: 400;
          font-size: vw(13);
          color: rgba($color: #050b27, $alpha: 0.8);
          line-height: vw(18);
          margin-left: vw(8);
        }
      }
    }

    .pop-btn-box {
      width: vw(335);
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: vw(20);

      .pop-btn-box-item {
        width: vw(140);
        height: vw(48);
        box-sizing: border-box;
        background: #ffffff;
        border-radius: vw(24);
        font-weight: 400;
        font-size: vw(16);
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .pop-btn-box-item-add {
        width: vw(210);
        background: #ff2270;
        color: #fff;
        font-weight: 500;
      }
    }
  }
}
</style>
